import { FC } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { IChangelogRecord } from "../../../interfaces";
import "./style.css";

interface Props {
  changelogRecords: IChangelogRecord[];
  onDeleteChangelogRecordClick: (changelogRecord: IChangelogRecord) => void;
}

export const ChangelogList: FC<Props> = ({
  changelogRecords,
  onDeleteChangelogRecordClick,
}) => {
  return (
    <div className="changelog-list-wrapper">
      <p className="changelog-list-wrapper-title">
        Added changelog records: {changelogRecords.length}
      </p>
      {changelogRecords?.map((changelogRecord) => {
        const { id, tags, description } = changelogRecord;

        return (
          <div className="changelog-list-item" key={id}>
            <MdDeleteOutline
              onClick={() => onDeleteChangelogRecordClick(changelogRecord)}
            />
            <div className="changelog-list-item-section">
              <p>Id:</p>
              {id}
            </div>
            <div className="changelog-list-item-section tags">
              <p>Tags:</p>
              <ul>
                {tags.map((tag) => (
                  <li key={tag}>{tag.toUpperCase()}</li>
                ))}
              </ul>
            </div>
            <div className="changelog-list-item-section">
              <p>Description:</p>
              {description}
            </div>
          </div>
        );
      })}
    </div>
  );
};
